import { render, staticRenderFns } from "./JoszakiHeading.vue?vue&type=template&id=53c1d8f5"
import script from "./JoszakiHeading.vue?vue&type=script&lang=js"
export * from "./JoszakiHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports